import axios from "axios";
import { DISH_API_URL, DISHTYPE_API_URL, MENU_API_URL, ROOM_API_URL, SCHEDULE_API_URL } from "./apisConfig";

const CreateSchedule = (retreatId,retreatLessionId,usedRoomId,lessonDate,lessonStart,lessonEnd) => {
    return axios.post(SCHEDULE_API_URL, { 
        retreatId,
        retreatLessionId,
        usedRoomId,
        lessonDate,
        lessonStart,
        lessonEnd
    }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const UpdateSchedule = (id,retreatLessonId,usedRoomId,lessonDate,lessonStart,lessonEnd) => {
    return axios.put(SCHEDULE_API_URL+`/${id}`, { 
        retreatLessonId,
        usedRoomId,
        lessonDate,
        lessonStart,
        lessonEnd
    }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const DeleteSchedule = (id) => {
    return axios.delete(SCHEDULE_API_URL + `/${id}`,{
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}
//API ROOM
const GetAllRooms = () => {
    return axios.get(ROOM_API_URL +`?pageSize=1000` , { 
        withCredentials: true,
    }
    
    );
}

//API MENU
const GetAllDishs = (pageNumber, name = '') => {
    const params = new URLSearchParams({ pageNumber });

    if (name) {
        params.append('name', name);
    }
    return axios.get(DISH_API_URL + `?${params.toString()}`, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetDishsBySize = (pageSize) => {
    return axios.get(DISH_API_URL + `?pageSize=${pageSize}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const CreateDish = (formData) => {
    return axios.post(DISH_API_URL, formData, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetDishByID = (id) => {
    return axios.get(DISH_API_URL + `/${id}`, { 
        id,
    });
}

const UpdateDish = (id, formData) => {
    return axios.put(DISH_API_URL + `/${id}`, formData, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
};

const DeleteDish = (id) => {
    return axios.delete(DISH_API_URL + `/${id}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const CreateMenu = (formData) => {
    return axios.post(MENU_API_URL, formData, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const DeleteMenu = (id) => {
    return axios.delete(MENU_API_URL + `/${id}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const UpdateMenu = (id, formData) => {
    return axios.put(MENU_API_URL + `/${id}`, formData, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
};

//API DISH TYPE
const GetAllDishTypes = () => {
    return axios.get(DISHTYPE_API_URL, { 
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}



export {CreateSchedule,GetAllRooms,DeleteSchedule,UpdateSchedule,
        GetAllDishs,CreateDish,GetDishByID,UpdateDish,DeleteDish,GetAllDishTypes,GetDishsBySize,
        CreateMenu,DeleteMenu,UpdateMenu
}